import React, { useEffect, useState } from 'react';
import { Typography } from '@telus-uds/components-web';
import { useLocaleContext } from '../context/LocaleContext';
import { contentfulPagesConfig, getContentfulData, getMultipleData } from '../contentful';
import ValidateLoader from '../UI/validateLoader';
import { pagesNames } from '../utils/constant';
import { listStyle, stylePage } from './styles';

const HowToVideos = ({ }) => {
  const { locale } = useLocaleContext();
  const [page, setPage] = useState(null);
  const [loader, setLoader] = useState(true);
  const config = { ...contentfulPagesConfig, locale };
  
  useEffect(() => {
    getContentfulData(config).then(res => {
      const result = getMultipleData(res);
      const { fields: howToVideosPage } = result.find(r => r.fields.name === pagesNames.HOW_TO_VIDEOS)
      setPage(howToVideosPage);
      setLoader(false);
    });
  }, [locale]);

  const renderFields = (fields) => {
    return (
      <ul style={listStyle}>
        {fields.map(({ fields: { label, value } }) =>
          <li key={label}>
            <a variant="link" href={value} style={{ color: '#4b286d' }} target="_blank">
              <Typography>{label}</Typography>
            </a>
            <br />
          </li>
        )}
      </ul>
    )
  }

  const renderPage = ({ title, fields }) => {
    return (
      <>
        <Typography heading="h2" variant={{ size: 'h2' }} block>{title}</Typography>
        <br />
        {renderFields(fields)}
      </>
    )
  }

  return (
    <div style={stylePage}>
      <div className="container 85%">
        <div id="main">
          <div id="main-wrapper">
            <div id="main-content">
              {loader ? <ValidateLoader message={"Loading"} /> : renderPage(page)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HowToVideos;
